"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2221,7364],{

/***/ 7784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./utils/apiClient.ts
var apiClient = __webpack_require__(77364);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./Layout/PreconDetail/Header/Form/usePreLead.ts







var schema = es/* object */.Ry({
    firstName: es/* string */.Z_().required().label("first name"),
    lastName: es/* string */.Z_().optional().label("last name"),
    phone: es/* string */.Z_().min(14).max(16).required(),
    email: es/* string */.Z_().email().required(),
    isRealtor: es/* boolean */.O7().optional(),
    message: es/* string */.Z_().optional()
}).required();
var usePreLead = function(callback) {
    var ref = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema)
    }), register = ref.register, handleSubmit = ref.handleSubmit, setError = ref.setError, _formState = ref.formState, errors = _formState.errors, isDirty = _formState.isDirty;
    var router = (0,next_router.useRouter)();
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(result) {
            var email, firstName, isRealtor, lastName, message, phone, res, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = result.email, firstName = result.firstName, isRealtor = result.isRealtor, lastName = result.lastName, message = result.message, phone = result.phone;
                        return [
                            4,
                            apiClient/* apiClient.post */.x.post("/api/v1/track/prelead", {
                                name: "".concat(firstName, " ").concat(lastName),
                                email: email,
                                phone: phone,
                                isRealtor: isRealtor,
                                message: message,
                                from: router.query.slug
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (!res.ok) {
                            if (res.error === "SERVER") {
                                ;
                                (ref = res.message) === null || ref === void 0 ? void 0 : ref.map(function(err) {
                                    setError("lastName", {
                                        message: err
                                    });
                                });
                            }
                        } else {
                            callback === null || callback === void 0 ? void 0 : callback();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(result) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        register: register,
        handleSubmit: handleSubmit,
        errors: errors,
        isDirty: isDirty,
        onSubmit: onSubmit
    };
};
/* harmony default export */ var Form_usePreLead = (usePreLead);

// EXTERNAL MODULE: ./node_modules/react-phone-number-input/min/index.js + 68 modules
var min = __webpack_require__(15034);
// EXTERNAL MODULE: ./node_modules/react-phone-number-input/style.css
var style = __webpack_require__(15922);
;// CONCATENATED MODULE: ./Layout/PreconDetail/Header/Form/index.tsx








var Errors = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9025).then(__webpack_require__.bind(__webpack_require__, 29025));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29025)
            ];
        }
    },
    suspense: true
});
var Thankyou = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6558).then(__webpack_require__.bind(__webpack_require__, 66558));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66558)
            ];
        }
    },
    suspense: true
});
var Index = function() {
    var ref = (0,react.useState)(false), sub = ref[0], setSub = ref[1];
    var ref1 = Form_usePreLead(function() {
        setSub(true);
    }), errors = ref1.errors, handleSubmit = ref1.handleSubmit, isDirty = ref1.isDirty, onSubmit = ref1.onSubmit, register = ref1.register;
    return sub === false ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: Object.values(errors).length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Loading..."
                        })
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Errors, {
                        errors: Object.values(errors)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("firstName")), {
                        className: "bg-white outline-none border-none px-2 py-[0.4rem] w-1/2 ",
                        placeholder: "First Name"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("lastName")), {
                        className: "bg-white outline-none border-none px-2 py-[0.4rem] w-1/2",
                        placeholder: "Last Name"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email")), {
                className: "bg-white outline-none border-none px-2 py-[0.4rem]",
                placeholder: "Email"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(min/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("phone")), {
                placeholder: "Enter phone number",
                defaultCountry: "CA",
                limitMaxLength: true,
                countryCallingCodeEditable: false,
                className: "bg-white outline-none border-none px-2 py-[0.6rem]",
                onChange: function() {}
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "",
                        children: "Are you a Realtor?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        id: "yes"
                                    }, register("isRealtor")), {
                                        value: "true",
                                        type: "radio"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "yes",
                                        children: "Yes"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        id: "no"
                                    }, register("isRealtor")), {
                                        value: "false",
                                        type: "radio"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "No",
                                        children: "No"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("message")), {
                className: "bg-white outline-none border-none px-2 py-[0.4rem]",
                placeholder: "Message"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                disabled: !isDirty,
                className: "bg-primary text-white py-2",
                children: "Submit"
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thankyou, {})
    });
};
/* harmony default export */ var Form = (Index);


/***/ }),

/***/ 77364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ apiClient; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50196);

var apiClient = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.bungalowfinder.ca"
});
// export const apiClient = axios.create({
//   baseURL: "http://127.0.0.1:2000",
// });
apiClient.interceptors.request.use(function(config) {
    var token = localStorage.getItem("token");
    if (!token) return config;
    if (config.headers) {
        config.headers["Authorization"] = "Bearer ".concat(token);
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});
apiClient.interceptors.response.use(function(res) {
    var _res = {
        ok: true,
        data: res.data,
        status: res.status
    };
    return _res;
}, function(error) {
    var res = undefined;
    if (error.response) {
        var _message = [];
        _message.push(error.response.data.message);
        res = {
            status: error.response.status,
            error: "SERVER",
            message: _message,
            data: error.response.data,
            ok: false
        };
        if (res.status === 401) {
            localStorage.removeItem("token");
            window.dispatchEvent(new CustomEvent("unauth"));
        }
        return Promise.resolve(res);
    }
    if (error.request) {
        res = {
            status: 500,
            data: error.request,
            error: "CLIENT",
            message: error.message,
            ok: false
        };
        return Promise.resolve(res);
    }
    res = {
        status: 500,
        data: {},
        ok: false,
        error: "ANY",
        message: [
            "Internal Server Error"
        ]
    };
    return Promise.resolve(res);
});


/***/ })

}]);